module.exports = __webpack_public_path__ + "img/trophy.b3707651.svg";